import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import RichTextEditor from 'react-rte';
import { useParams } from "react-router";
import { OrganizationContext } from '../../../Services/OrganizationContext';
import authService from '../../../Services/authService';
import { useNavigate } from 'react-router-dom';
import Breadcrumb from "../Breadcrumb/Breadcrumb"

const EditBanner = () => {

  const navigate = useNavigate();
  const params = useParams();
  const id = params.id.toString();
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    Is_Active: '',
  });
  const { organization } = useContext(OrganizationContext);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);
  const [file, setFile] = useState(null);
  const [editorState, setEditorState] = useState(RichTextEditor.createEmptyValue());

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    const token = authService.getCurrentadmin().token; // Retrieve the token for authorizationauthorization // Retrieve the token for authorization

    // Construct the URL with the organization_id as a query parameter
    const url = new URL(authService.getApiUrl() + 'banners/' + id);
    //url.searchParams.append('organization_id', organization); // Append the organization_id as a query parameter

    fetch(url, {
      method: 'GET', // Set method to GET
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${token}`, // Include Authorization header with Bearer token if required
      },
    })
      .then((res) => {
        if (res.status === 401) {
          // If status is 401, redirect to the login page
          authService.logout();
          window.location.href = "/admin";
        } else {
          return res.json(); // Proceed with parsing JSON if the response is okay
        }
      })
      .then((result) => {
        const data = result.data;
        setFormData({
          ...data,
          Is_Active: data.Is_Active === "A",  // Convert "A" to true and "I" to false
        });
      })
      .catch((err) => {
        console.log(err.message); // Handle any errors
      });

  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFile(e.target.files[0]);
    // setFormData({
    //   ...formData,
    //   image: file,
    // });
  };





  const convertImageToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      // Resolve the base64 string when the file is successfully read
      reader.onload = () => resolve(reader.result);

      // Reject in case of any errors
      reader.onerror = error => reject(error);
    });
  };

  const [errors, setErrors] = useState({});

  const handleSubmit = async (event) => {
    event.preventDefault();

    const ValidationErrors = ValidateForm(formData);
    setErrors(ValidationErrors);
    if (Object.keys(ValidationErrors).length === 0) {
      const token = authService.getCurrentadmin().token; // Retrieve the token for authorizationauthorization // Retrieve the token for authorization
      const base64String = file ? await convertImageToBase64(file) : "";
      fetch(authService.getApiUrl() + 'updatesbanner/' + id, {
        method: 'PUT', // Change method to PUT
        body: JSON.stringify({

          title: formData.title,
          image: base64String,
          description: formData.description,
          Is_Active: formData.Is_Active ? "A" : "I",

        }), // Include the data to be updated in the body
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${token}`, // Add Authorization header with Bearer token
        },
      })
        .then((res) => res.json())
        .then((result) => {
          //setFormData(result.data); // Set the form data with the result
          navigate(`/admin/banners`);
          //console.log(result.data)
        })
        .catch((err) => {
          console.log(err.message); // Handle any errors
        });
    } else {
      console.log("form does not submit due to validations");
    }

  };


  const ValidateForm = () => {
    const errors = {};
    const nameRegex = /^[a-z A-Z]+$/;
    const phoneRegex = /^[6,7,8,9][0-9]{0,9}$/;

    if (!formData.title) {
      errors.title = 'Title is required';
    } else if (formData.title.length < 4) {
      errors.name = 'Title must be at least 4 characters';
    } else if (!nameRegex.test(formData.title)) {
      errors.title = 'Title can only contain letters';
    }

    if (!formData.description) {
      errors.description = 'Description is required';
    }
    if (!formData.Is_Active) {
      errors.Is_Active = 'Please check the box is required';
    }

    return errors;
  };


  return (
    <div className='main-container'>
      <div className='container-fluid'>
        <Breadcrumb />

        <div className='category-table'>
          <div className='flex-cont add-cat'>
            <div className='heading'>
              <h3>Edit Banner</h3>
            </div>
          </div>
          <div className="card">
            <div className="card-body custom-edit-service">
              <form className="needs-validation clearfix" onSubmit={handleSubmit} >
                <div className="addtest-fields mb-3">
                  <div className="flex-cont">
                    <div className="full-cont">
                      <div className="form-group">
                        <label>
                          Title
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          value={formData.title}
                          onChange={handleInputChange}
                        // required
                        />
                        {errors.title && (<span className="errors">{errors.title}</span>)}
                      </div>
                    </div>


                    <div className="full-cont">
                      <div className='upload-img-cont'>
                        <span>Upload Image *</span>
                        <input
                          type="file"
                          accept="image/jpeg, image/png, image/gif"
                          name="image"
                          onChange={handleImageChange}
                          className="form-control"

                        />
                        <small className="text-secondary">
                          Recommended image size is <b>300 × 300 px</b>
                        </small>
                      </div>
                      {formData.image && (
                        <div id="uploadPreview">
                          <ul className="upload-wrap">
                            <li>
                              <div className="upload-images">
                                <img
                                  alt="Organization"
                                  src={authService.getApiDomainUrl() + formData.image}
                                  style={{ maxWidth: '100px', maxHeight: '100px' }}
                                />
                              </div>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>

                    <div className="full-cont pt-5">
                      <div className="form-group">
                        <label>
                          Description <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          name="description"
                          value={formData.description}
                          onChange={handleInputChange}
                          placeholder="Enter your message..."
                        />


                        {errors.description && (<span className="errors">{errors.description}</span>)}
                      </div>
                    </div>
                  </div>

                  <div className="full-cont special-case-cont">
                    <div className='form-group'>
                      <label className="custom-checkbox">
                        <input
                          type="checkbox"
                          name="Is_Active"
                          checked={formData.Is_Active}
                          onChange={handleInputChange}

                        />
                        <span className="checkmark"></span>
                        <label>Status </label>
                      </label>
                      {errors.Is_Active && (<span className="errors">{errors.Is_Active}</span>)}
                    </div>
                  </div>


                </div>
                <div className="submit-section">

                  <button
                    className="btn btn-primary submit-btn"
                    type="submit"
                    name="form_submit"
                    onSubmit={ValidateForm()}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBanner;
